import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { Toast } from '@10d/tend-ui/primitives/Toast';

import { get, del, post } from 'api/requests';

import { AppThunk } from 'store/types';
import { IParamsReq, IParamsCallEngineering } from 'types';
import { Calls, ReviewApartmentApointments } from 'pages/Calls/types';

interface CallsStore {
  list: Calls[];
  loading: boolean;
  count: number;
}

const initialState: CallsStore = {
  list: [],
  loading: false,
  count: 0,
};

const reset: CaseReducer<CallsStore> = () => initialState;

const loading: CaseReducer<CallsStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const count: CaseReducer<CallsStore, PayloadAction<number>> = (state, action) => {
  state.count = action.payload;
};

const list: CaseReducer<CallsStore, PayloadAction<Calls[]>> = (state, action) => {
  state.list = action.payload;
};

export const unAllocatedSlice = createSlice({
  name: 'calls_apartments_unAllocated',
  initialState,
  reducers: {
    reset,
    loading,
    list,
    count,
  },
});

const {
  reset: setReset,
  loading: setLoading,
  list: setCurrentCalls,
  count: setCallsCount,
} = unAllocatedSlice.actions;

export { setReset };

export const setCalls =
  (calls: Calls[]): AppThunk =>
  dispatch => {
    dispatch(setCurrentCalls(calls));
  };

export const getApartmentsUnallocatedCalls =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<UnallocatedCallsResponce>('/api/standards/placements/unallocated-list/', params)
      .then(({ data }) => {
        const { count, results } = data;
        dispatch(setCalls(results));
        dispatch(setCallsCount(count));
      })
      .finally(() => dispatch(setLoading(false)));
  };

type UnallocatedCallsResponce = {
  count: number;
  results: Calls[];
};

export const deleteApartmentUnallocatedCalls =
  (id: number, appointmentId: number): AppThunk =>
  (dispatch, getState) => {
    // TODO Надо передать id, посмотреть как. Так как сейчас просто в data id, мб нужно объектом {id:id} ?
    del(`/api/timesheet/appointments/${appointmentId}/delete_placement/`, {
      id,
    }).then(() => {
      const { calls } = getState();

      /* TODO type */
      const updatedData = calls.apartments.unAllocated.list.filter(
        (review: { id: number }) => review.id !== id,
      );
      const updatedCount = updatedData.length;

      dispatch(setCalls(updatedData));
      dispatch(setCallsCount(updatedCount));
      Toast.success({ message: 'Вызов успешно удален' });
    });
  };

export const resheduleApartmentUnallocatedCalls =
  (id: number, appointmentId: number, date: string): AppThunk =>
  (dispatch, getState) => {
    // TODO appointsment нет наверное
    post<{ id: number }, ReviewApartmentApointments>(
      `/api/timesheet/appointments/${appointmentId}/recall_placement/`,
      { id },
    ).then(({ data: { appointments } }) => {
      // TODO правильно ли деструктурируется
      const { calls } = getState();

      const reviewListCopy = [...calls.apartments.unAllocated.list];
      const indexOfEditedReview = reviewListCopy.findIndex(review => review.id === id);
      const editedReview = reviewListCopy.splice(indexOfEditedReview, 1);
      const updatedReview = {
        ...editedReview[0],
        date: date,
        appointmentId: appointments[0].id,
      };

      reviewListCopy.push(updatedReview);
      reviewListCopy.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

      dispatch(setCalls(reviewListCopy));
      Toast.success({ message: 'Вызов успешно перенесён' });
    });
  };

export const sendUnallocatedExcel = (reqData: IParamsReq): void => {
  post('/api/standards/placements/unallocated-list/excel/', reqData);
};

export const callEngineeringUnallocatedCalls = async (params: IParamsCallEngineering) => {
  await post('/api/v2/timesheet/meeting-engineer/', params);
};
